<template>
  <base-nav container-classes="container-fluid" class="navbar-top navbar-expand d-none d-lg-block"
    :style="{ backgroundColor: '#1e3a8a' }">
    <a href="#" aria-current="page"
      class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active">
      {{ routeName }}
    </a>

    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <li class="nav-item d-sm-none">
        <a class="nav-link text-white" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>

    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0 text-white" @click.prevent slot="title-container" style="height: 56px;">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm">
              <i class="ni ni-single-02 text-yellow"></i>
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">
                {{ userName }}
              </span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Selamat Datang</h6>
          </b-dropdown-header>

          <!-- Manual Pengguna/Pentadbir/Admin -->
          <b-dropdown-item-button @click="viewManual">
            <i class="ni ni-books"></i>
            <span>Manual Pengguna</span>
          </b-dropdown-item-button>

          <!-- Log Keluar -->
          <b-dropdown-item-button @click="logout">
            <i class="ni ni-user-run"></i>
            <span>Log Keluar</span>
          </b-dropdown-item-button>
        </template>

      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import { baseURL } from '../../services/baseURL';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    userName() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user && user.nama ? user.nama : 'User';
    },
    userImage() {
      return localStorage.getItem('userImage') || 'img/theme/team-4.jpg';
    },
    peranan() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user && user.peranan ? user.peranan.toLowerCase() : 'user';
    },
    manualLink() {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const peranan = (user.peranan || '').toLowerCase();
    const userType = user.userType;

    console.log('manualLink check:', { peranan, userType });

    if (peranan === 'admin') {
      return `${baseURL}/pdf/projek/User_Manual-DOKUMEN_MANUAL_PENGGUNA_v4_H.E.M.A.T.-Sekretariat.pdf`;
    }

    if (peranan === 'pentadbir awam') {
      return `${baseURL}/pdf/projek/User_Manual-DOKUMEN_MANUAL_PENGGUNA_v4_H.E.M.A.T.-Pentadbir_Organisasi-Bukan_HRMIS.pdf`;
    }

    if (peranan === 'pengguna') {
      if (userType === 'public') {
        return `${baseURL}/pdf/projek/User_Manual-DOKUMEN_MANUAL_PENGGUNA_v1_H.E.M.A.T.-Pengguna.pdf`;
      } else {
        return `${baseURL}/pdf/projek/User_Manual-DOKUMEN_MANUAL_PENGGUNA_v4_H.E.M.A.T.-Pentadbir_Agensi.pdf`;
      }
    }

    // fallback umum
    return `${baseURL}/pdf/projek/User_Manual-DOKUMEN_MANUAL_PENGGUNA_v4_H.E.M.A.T.-Pentadbir_Organisasi-HRMIS.pdf`;
  }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    };
  },
  methods: {
    viewManual() {
      window.open(this.manualLink, '_blank');
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    logout() {
      localStorage.clear();
      this.$store.commit('logoff');
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
/* Navbar behavior */
.navbar-top {
  position: sticky;
  top: 0;
  z-index: 1030;
}

/* Avatar styles */
.avatar-sm {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.ni-single-02 {
  font-size: 1rem;
}

/* Header spacing */
.header.bg-gradient-deli.bg-success {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

/* Buang style untuk mask kerana elemen tersebut telah dibuang */
/* .mask.bg-gradient-darkblue.opacity-8 {
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  top: 0 !important;
  position: absolute !important;
  width: 100% !important;
  overflow: hidden !important;
} */

/* Pastikan container tidak ada margin tambahan */
.content-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
